import { SectorOutputDTO } from '@types';

export const SectorMapper = {
  toDTO: (data: Partial<SectorOutputDTO>): Partial<SectorOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: SectorOutputDTO): SectorOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 